module.exports = __webpack_public_path__ + "static/media/defaultImage.2f047902.svg";